import { PluginKey } from '@tiptap/pm/state';

/** One instance: the app plugin registers it, package hooks dispatch rebuild meta on it. */
export const entityVerificationPluginKey = new PluginKey('entityVerificationHighlight');
